module.exports = __webpack_public_path__ + "img/planner.6b540498.svg";